// extracted by mini-css-extract-plugin
module.exports = {"suggestedDishList":"_21Z-eDYQAgfk-ZxJTSJNSP","externalId":"_1EMysXpng324rw21IlVxrG"};